import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import {
  Avatar,
  Badge,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  Modal,
  Progress,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Tag,
  Typography,
} from "antd";
import {
  ChartColumnStacked,
  Check,
  CheckCircle,
  CircleAlert,
  Edit,
  Filter,
  NotepadText,
  Plus,
  RotateCw,
  Trash2,
  UserRound,
} from "lucide-react";

import { notificationErroInternal, notificationInfo } from "util/api-utils";
import { BRANCH_STORAGE, FONT } from "constants/index";

import { ListEmptyState } from "views/util/emptyState";
import { getUsers } from "services/user/user-service";
import {
  closeTrainingAquatic,
  closeTrainingAquaticBoot,
  doneTrainingAquatic,
  doneTrainingAquaticBoot,
  getPhasesAquatic,
  getUsersReviewsAqua,
  getUsersToTreiningAquatic,
  getUsersToTreiningAquaticBoot,
  openTrainingAquatic,
  saveAnnotationAquatic,
  saveTrainingAqua,
  updateTask,
} from "services/aquatic/aquatic-service";
import { toRoman } from "views/util/roman";
import DrawerApp from "components/drawer-app";
import DetailAquatic from "./managerial-detail-aqua";
import ProgressoRadarChart from "./managerial-chart-aqua";
import FormTrainningBootAqua from "../trainning/trainning-drawer-boot-aqua";
import ManageralAguaFilter from "./manageral-aqua-filter";
import { startSSE, syncEvo } from "services/evo/evo-service";
import useBreakpoint from "hooks/useBreakpoint";
import PageToolbar from "components/page-toolbar";
import { drawerWidth } from "util/responsive";

const { Meta } = Card;
const { confirm } = Modal;
const { TextArea } = Input;

const ManagerialAqua = () => {
  const { isMobile, isDesktop } = useBreakpoint();
  const useStackedLayout = !isDesktop;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(Date.now());
  const [formOpenUser] = Form.useForm();
  const [dataUsers, setDataUsers] = useState([]);
  const [phases, setPhases] = useState([{ subphases: [] }]);
  const [formAnnotation] = Form.useForm();
  const [openDetail, setOpenDetail] = useState(false);
  const [userTrainer, setUserTrainer] = useState(null);
  const [openChart, setOpenChart] = useState(false);
  const [dataBoot, setDataBoot] = useState([]);
  const [activeFilterCount, setActiveFilterCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [openTask, setOpenTask] = useState(false);
  const [userTasks, setUserTask] = useState([]);
  const [phaseActual, setPhaseActual] = useState({
    phase: { subphases: [] },
    subphase: {},
  });
  const [filters, setFilters] = useState({});
  const [syncLoading, setSyncLoading] = useState(false);

  const eventSourcesRef = useRef({}); 

  useEffect(() => {
    refreshData(filters);
    return () => {
      Object.values(eventSourcesRef.current).forEach((es) => es.close());
    };
  }, []);

  useEffect(() => {
    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith("exercise-scroll-aqua")) {
        sessionStorage.removeItem(key);
      }
    });
  }, []);

  const refreshData = async (filter) => {
    await getAll(filter);
  };
  async function getAll(filter) {
    try {
      setLoading(true);
      setLastUpdated(Date.now());
      await Promise.all([
        getData(filter),
        getUsersToTreining(),
        getPhases(),
        getDataBoot(),
      ]);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      setLoading(false);
    }
  }
  const getPhases = async () => {
    try {
      const data = await getPhasesAquatic();
      setPhases(data);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    }
  };

  async function getData(filter) {
    try {
      let param = {};
      if (filter) {
        param = Object.fromEntries(
          Object.entries(filter).filter(([key, value]) => value !== undefined)
        );
      }

      const data = await getUsersToTreiningAquatic(param);
      const dataFinal = [...data.filter((item) => item.isBoot != true)];
      setData(dataFinal);
      if (userTrainer && userTrainer.isBoot != true) {
        const newUser = dataFinal.find((item) => item.id == userTrainer.id);
        setUserTrainer(newUser);
        const phaseActual = findSubphaseById(newUser.training?.subphasesId);
        setPhaseActual(phaseActual)
      }
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    }
  }
  async function getDataBoot() {
    try {
      const data = await getUsersToTreiningAquaticBoot();
      setDataBoot(data);
      if (userTrainer && userTrainer.isBoot == true) {
        const newUser = data.find((item) => item.id == userTrainer.id);
        setUserTrainer(newUser);
      }
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    }
  }
  async function getUsersToTreining() {
    try {
      const users = await getUsers();
      const dataBoot = await getUsersReviewsAqua();
      const dataFinal = [
        ...users.filter((item) => item.isBoot != true),
        ...dataBoot.filter((item) => item.lastReview != null),
      ];
      setDataUsers(dataFinal);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    }
  }
  const DescriptionItem = ({ title, style }) => (
    <div
      className="site-description-item-profile-wrapper"
      style={
        style
          ? style
          : {
              fontFamily: FONT,
              fontSize: useStackedLayout ? 13 : 14,
              fontWeight: 500,
            }
      }
    >
      {title}
    </div>
  );

  const CardField = ({ label, value }) => (
    <div className="card-field">
      <span className="card-field-label">{label}</span>
      <span className="card-field-value">{value}</span>
    </div>
  );

  const saveTask = async (status, taskId, userId) => {
    setLoading(true);

    try {
      await updateTask(taskId + "/" + status, { userId: userId });
      refreshData(filters);

    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  };
  const calcPercent = (tasksDone = [], objectives = []) => {
    const objectiveTaskIds = new Set(
      objectives.flatMap((obj) => obj.tasks?.map((task) => task.id) || [])
    );

    const filteredDone = tasksDone.filter((done) =>
      objectiveTaskIds.has(done.taskId)
    );

    const totalTasks = objectiveTaskIds.size;
    const doneCount = filteredDone.length;

    if (totalTasks === 0) return 0;

    const percent = (doneCount / totalTasks) * 100;

    return Math.round(percent);
  };
  const onCloseDetail = () => {
    setOpenDetail(false);
    setUserTrainer({});
    setPhaseActual({
      phase: { subphases: [] },
      subphase: {},
    })
    refreshData(filters);
    
  };
  const onCloseChart = () => {
    setOpenChart(false);
  };

  async function updateEvo() {
    setSyncLoading(true);
    try {
      const { id } = JSON.parse(localStorage.getItem(BRANCH_STORAGE));
      const param={
        branchId: id
      }
      await syncEvo(param);
      startSSE(id, eventSourcesRef, finishedSync);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
      setSyncLoading(false)
    }
  }
  async function finishedSync(){
    setSyncLoading(false)
    refreshData(filters)
  }

  function getActionCard(user, isBoot) {
    return [
      <div
        onClick={() => {
          openAnotation(user, isBoot);
        }}
      >
        <NotepadText />
      </div>,
      <div
        onClick={() => {
          const phaseActual = findSubphaseById(user.training?.subphasesId);
          setPhaseActual(phaseActual)
          setUserTrainer(user);
          setOpenChart(true);
        }}
      >
        <ChartColumnStacked />
      </div>,
      ...(isBoot != true
        ? [
            <div
              onClick={() => {
                setUserTrainer(user);
                setOpenDetail(true);
              }}
            >
              <Edit />
            </div>,
          ]
        : []),
      <div
        onClick={() => {
          closeTreining(user, isBoot);
        }}
      >
        <Trash2 />
      </div>,
      <div onClick={() => saveTreining(user, isBoot)}>
        <Check />
      </div>,
    ];
  }
  const Exercises = ({ exercises, userId, tasksDone = [] }) => {
    const scrollRef = useRef(null);
    const storageKey = `exercise-scroll-aqua-${userId}`;

    useLayoutEffect(() => {
      const savedScroll = sessionStorage.getItem(storageKey);
      if (scrollRef.current && savedScroll) {
        scrollRef.current.scrollTop = parseInt(savedScroll, 10);
      }
    }, [storageKey]);

    const handleScroll = () => {
      if (scrollRef.current) {
        sessionStorage.setItem(
          storageKey,
          scrollRef.current.scrollTop.toString()
        );
      }
    };
    return (
      <div
        ref={scrollRef}
        onScroll={handleScroll}
        style={{
          maxHeight: 300,
          overflowY: "auto",
          overflowX: useStackedLayout ? "hidden" : "auto",
        }}
        className={`custom-scroll ${
          useStackedLayout ? "exercise-list-mobile" : "exercise-list-desktop"
        }`}
      >
        {exercises.map((exercise, index) => {
          const allTasksExecuted = exercise.tasks.every((task) =>
            tasksDone.some((done) => done.taskId === task.id)
          );

          const executedTasks = exercise.tasks.filter((task) =>
            tasksDone.some((done) => done.taskId === task.id)
          );
          const highest =
            executedTasks.length > 0
              ? executedTasks.reduce((max, task) =>
                  task.order > max.order ? task : max
                ).order + 1
              : 1;

          const task = exercise.tasks.find((item) => item.order === highest);
          const roman = highest > 0 ? toRoman(highest) : "I";

          return (
            <div key={index}>
              <Row>
                <Col span={24}>
                  <Card
                    style={{
                      backgroundColor: "#ffff",
                      margin: 5,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setUserTask(exercise.tasks);
                      setOpenTask(true);
                    }}
                  >
                    <Row justify="space-between" align="middle">
                      <Col>
                        <DescriptionItem title={exercise.name} />
                      </Col>
                      {!allTasksExecuted && (
                        <Col>
                          <DescriptionItem title={roman} />
                        </Col>
                      )}
                    </Row>
                    {allTasksExecuted && (
                      <DescriptionItem
                        title={"Todas as tarefas concluídas!"}
                        style={{
                          fontFamily: FONT,
                          fontSize: 13,
                          fontWeight: 300,
                          color: "#09ac9c",
                        }}
                      />
                    )}
                    {!allTasksExecuted && (
                      <>
                        <DescriptionItem
                          title={task?.name}
                          style={{
                            fontFamily: FONT,
                            fontSize: 13,
                            fontWeight: 300,
                          }}
                        />
                        <Button
                          type="primary"
                          style={{
                            backgroundColor: "#e6fffb",
                            borderColor: "#fff",
                            color: "#09ac9c",
                            borderRadius: 12,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            saveTask("DONE", task?.id, userId);
                          }}
                          icon={
                            <CheckCircle
                              size={18}
                              style={{
                                marginBottom: "-3px",
                                marginRight: "7px",
                              }}
                            />
                          }
                        >
                          Concluir
                        </Button>
                      </>
                    )}
                  </Card>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>
    );
  };
  const Tasks = ({ tasks }) => {
    return (
      <div
        style={{
          overflowY: "auto",
          overflowX: "auto",
        }}
        className="custom-scroll"
      >
        {tasks.map((task, index) => {
          const roman = task.order > 0 ? toRoman(task.order) : "I";

          return (
            <div key={index}>
              <Row>
                <Col span={24}>
                  <Card style={{ backgroundColor: "#ffff", margin: 5 }}>
                    <Row justify="space-between" align="middle">
                      <Col>
                        <DescriptionItem title={task.name} />
                      </Col>
                      <Col>
                        <DescriptionItem title={roman} />
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>
    );
  };
  const CardTrainings = ({ usersTrainings }) => {
    return usersTrainings.map((user) => {
      const phaseActual = findSubphaseById(user.training?.subphasesId);
      const subPhasesOptions = phaseActual?.phase?.subphases?.map((item) => {
        return { label: item.name, value: item.id, order: item.order };
      });
      const evolution = calcPercent(
        user?.tasksDone ?? [],
        phaseActual?.subphase?.objectives ?? []
      );

      const idSubPhase =
        evolution < 34 ? 1 : evolution > 33 && evolution < 67 ? 2 : 3;
      const subPhaseName = subPhasesOptions?.find(
        (item) => item.order == idSubPhase
      );
      return (
        <Col key={user.id} xs={24} lg={12}>
          <Card
            className="training-card"
            style={{
              width: "100%",
              marginBottom: 16,
              display: "flex",
              flexDirection: "column",
            }}
            actions={getActionCard(user, false)}
          >
            <Meta
              className="training-card-meta"
              avatar={
                <Avatar
                  src={user?.img}
                  icon={
                    <UserRound size={useStackedLayout ? 48 : 56} />
                  }
                  size={useStackedLayout ? 48 : 56}
                />
              }
              title={ user?.isBoot == null ? 
                <div>
                  <p style={{ marginBottom: 2 }}>{user.name}</p>
                  <p style={{ fontSize: 12, fontWeight: 400, marginBottom: 0 }}>
                    Nível: {phaseActual?.phase?.name}
                  </p>
                </div>
                : 
                <div>
                <p style={{ marginBottom: 2 }}>{user.name}</p>
                <p style={{ fontSize: 12, fontWeight: 400, marginBottom: 0 }}>
                  Nível: {phaseActual?.phase?.name} - {subPhaseName?.label}
                </p>
              </div>
              }
              description={
                <div>
                  <Progress
                    percent={calcPercent(
                      user.tasksDone,
                      phaseActual?.subphase?.objectives ?? []
                    )}
                    size="small"
                    style={{
                      marginBottom: 8,
                      paddingLeft: useStackedLayout ? 15 : 0,
                    }}
                  />

                  <Exercises
                    exercises={phaseActual?.subphase?.objectives ?? []}
                    userId={user.id}
                    tasksDone={user.tasksDone}
                  />
                </div>
              }
            />
          </Card>
        </Col>
      );
    });
  };
  const MetragensBoot = ({ review }) => {
    const rows = [
      {
        label: "100",
        a1: review.zone100A1 + " - " + review.zone100A1Base,
        a2: review.zone100A2 + " - " + review.zone100A2Base,
        a3: review.zone100A3 + " - " + review.zone100A3Base,
      },
      {
        label: "200",
        a1: review.zone200A1Base + " - " + review.zone200A1,
        a2: review.zone200A2 + " - " + review.zone200A2Base,
        a3: review.zone200A3 + " - " + review.zone200A3Base,
      },
      {
        label: "300+",
        a1: review.zone300A1Base + " - " + review.zone300A1,
        a2: review.zone300A2 + " - " + review.zone300A2Base,
        a3: review.zone300A3 + " - " + review.zone300A3Base,
      },
    ];

    if (useStackedLayout) {
      return (
        <div className="exercise-list-mobile">
          {rows.map((row, index) => (
            <div
              key={index}
              className="responsive-card-item metragens-row-mobile"
            >
              <CardField label="Metragem" value={row.label} />
              <CardField label="A1" value={row.a1} />
              <CardField label="A2" value={row.a2} />
              <CardField label="A3" value={row.a3} />
            </div>
          ))}
        </div>
      );
    }

    return (
      <div className="metragens-table-desktop">
        <div className="metragens-table-header">
          <span>Metragem</span>
          <span>A1</span>
          <span>A2</span>
          <span>A3</span>
        </div>
        {rows.map((row, index) => (
          <div key={index} className="metragens-table-row">
            <span>{row.label}</span>
            <span>{row.a1}</span>
            <span>{row.a2}</span>
            <span>{row.a3}</span>
          </div>
        ))}
      </div>
    );
  };
  const CardTrainingsBoot = ({ usersTrainings }) => {
    return usersTrainings.map((user) => {
      const [formUser] = Form.useForm();
      formUser.setFieldValue("load", user.training.load);
      formUser.setFieldValue("vmp1", user.training.vmp1);
      formUser.setFieldValue("pse", user.training.pse);
      return (
        <Col key={user.id} xs={24} lg={12}>
          <Card
            className="training-card"
            style={{
              width: "100%",
              marginBottom: 16,
              display: "flex",
              flexDirection: "column",
            }}
            actions={getActionCard(user, true)}
          >
            <Meta
              className="training-card-meta"
              avatar={
                <Avatar
                  src={user?.img}
                  icon={
                    <UserRound size={useStackedLayout ? 48 : 56} />
                  }
                  size={useStackedLayout ? 48 : 56}
                />
              }
              title={
                <div>
                  <p style={{ marginBottom: 0 }}>{user.name}</p>
                </div>
              }
              description={
                <div
                  className={
                    useStackedLayout ? "exercise-list-mobile" : ""
                  }
                >
                  <MetragensBoot review={user.review} />
                  <div className="training-card-section">
                    <div className="training-card-section-title">Treino</div>
                    <Form
                      form={formUser}
                      layout="vertical"
                      className={
                        useStackedLayout ? "training-card-form-mobile" : ""
                      }
                    >
                      {useStackedLayout ? (
                        <Row gutter={16}>
                          <Col xs={24}>
                            <Form.Item name="load" label="Metragem/Dia">
                              <InputNumber
                                style={{ fontFamily: FONT, width: "100%" }}
                                onBlur={() =>
                                  setTraining(formUser, user.training.id)
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24}>
                            <Form.Item name="vmp1" label="Tempo (min,seg)">
                              <InputNumber
                                decimalSeparator=","
                                style={{ fontFamily: FONT, width: "100%" }}
                                onBlur={() =>
                                  setTraining(formUser, user.training.id)
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24}>
                            <Form.Item name="pse" label="PSE">
                              <InputNumber
                                style={{ fontFamily: FONT, width: "100%" }}
                                onBlur={() =>
                                  setTraining(formUser, user.training.id)
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      ) : (
                        <div className="training-form-grid">
                          <Form.Item name="load" label="Metragem/Dia">
                            <InputNumber
                              style={{ fontFamily: FONT, width: "100%" }}
                              onBlur={() =>
                                setTraining(formUser, user.training.id)
                              }
                            />
                          </Form.Item>
                          <Form.Item name="vmp1" label="Tempo (min,seg)">
                            <InputNumber
                              decimalSeparator=","
                              style={{ fontFamily: FONT, width: "100%" }}
                              onBlur={() =>
                                setTraining(formUser, user.training.id)
                              }
                            />
                          </Form.Item>
                          <Form.Item name="pse" label="PSE">
                            <InputNumber
                              style={{ fontFamily: FONT, width: "100%" }}
                              onBlur={() =>
                                setTraining(formUser, user.training.id)
                              }
                            />
                          </Form.Item>
                        </div>
                      )}
                    </Form>
                  </div>
                </div>
              }
            />
          </Card>
        </Col>
      );
    });
  };

  const formatTime = (date) => {
    if (!date) return "Nunca atualizado";
    return new Intl.DateTimeFormat("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(date);
  };

  function updateList() {
    const idsToRemove = new Set([
      ...data.map((item) => item.id),
      ...dataBoot.map((item) => item.id),
    ]);
    const result = dataUsers.filter((item) => !idsToRemove.has(item.id));

    if (result.length == 0) {
      notificationInfo(
        "Todos os alunos disponíveis estão no painel ou com cíclos finalizados"
      );
      return;
    }

    const resultOrder = result.sort((a, b) => a.name.localeCompare(b.name));
    openTraing(resultOrder);
  }

  function openTraing(result) {
    confirm({
      title: (
        <div>
          <CircleAlert size={22} style={{ marginBottom: "-5px" }} />
          <span style={{ marginLeft: "10px", fontFamily: FONT }}>
            Qual Aluno ?
          </span>
          <div style={{ marginTop: "10px" }}>
            <Form form={formOpenUser} layout="vertical">
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item name="userOpen">
                    <Select
                      mode="multiple"
                      showSearch
                      optionFilterProp="children"
                    >
                      {result.map((item) => {
                        return <Option value={item.id}>{item.name}</Option>;
                      })}
                    </Select>
                  </Form.Item>
                  <Form.Item name="typeOpen">
                    <Radio.Group
                      options={[
                        { label: "Último Treino", value: "LAST" },
                        { label: "Novo Treino", value: "NEW" },
                      ]}
                      defaultValue={"NEW"}
                      optionType="button"
                      buttonStyle="solid"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      ),
      icon: null,
      okText: "Selecionar",
      cancelText: "Cancelar",
      async onOk() {
        setLoading(true);

        const users = formOpenUser.getFieldValue("userOpen");

        const usersNotBoot = [];
        const usersBoot = [];
        users?.forEach((userId) => {
          const usersNotBootId = dataUsers.filter(
            (d) => d.id == userId && d.isBoot != true
          );
          const usersBootId = dataUsers.filter(
            (d) => d.id == userId && d.isBoot == true
          );
          if (usersNotBootId.length > 0) {
            usersNotBoot.push(userId);
          }
          if (usersBootId.length > 0) {
            usersBoot.push(userId);
          }
        });

        if (usersNotBoot.length == 0 && usersBoot.length == 0) {
          notificationInfo("É nescessário informar o aluno");
          setLoading(false);
          return;
        }

        const typeOpen = formOpenUser.getFieldValue("typeOpen");
        try {
          if (usersNotBoot.length > 0) {
            const objNotBoot = {
              users: usersNotBoot,
              typeOpen: typeOpen ?? "NEW",
              typeUser: "NOT_BOOT",
            };
            await openTrainingAquatic(objNotBoot);
          }
          if (usersBoot.length > 0) {
            const objUsersBoot = {
              users: usersBoot,
              typeOpen: typeOpen ?? "NEW",
              typeUser: "BOOT",
            };

            await openTrainingAquatic(objUsersBoot);
          }
          refreshData(filters);
        } catch (error) {
          notificationErroInternal(
            "Aconteceu um erro inesperado, por favor, tente mais tarde."
          );
        } finally {
          setLoading(false);
          formOpenUser.resetFields();
        }
      },
      onCancel() {
        formOpenUser.resetFields();
      },
    });
  }

  const findSubphaseById = (subphaseId) => {
    for (const phase of phases) {
      const found = phase.subphases.find((sub) => sub.id === subphaseId);
      if (found) {
        return { phase, subphase: found };
      }
    }
    return null;
  };

  function openAnotation(user, isBoot) {
    const annotation = user.training.annotation;

    formAnnotation.setFieldValue("userAnnotation", annotation);
    confirm({
      title: (
        <div>
          <CircleAlert size={22} style={{ marginBottom: "-5px" }} />
          <span style={{ marginLeft: "10px", fontFamily: FONT }}>
            Anotações do Treino
          </span>
          <div style={{ marginTop: "10px" }}>
            <Form form={formAnnotation} layout="vertical">
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item name="userAnnotation">
                    <TextArea rows={8} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      ),
      icon: null,
      okText: "Salvar",
      cancelText: "Cancelar",
      async onOk() {
        setLoading(true);

        const obj = {
          trainingId: user.training.id,
          annotation: formAnnotation.getFieldValue("userAnnotation"),
          isBoot: isBoot,
        };
        try {
          await saveAnnotationAquatic(obj);
          refreshData(filters);
        } catch (error) {
          notificationErroInternal(
            "Aconteceu um erro inesperado, por favor, tente mais tarde."
          );
        } finally {
          setLoading(false);
          formAnnotation.resetFields();
        }
      },
      onCancel() {
        formAnnotation.resetFields();
      },
    });
  }

  async function closeTreining(user, isBoot) {
    setLoading(true);
    try {
      if (isBoot) {
        await closeTrainingAquaticBoot(user.training.id);
      } else {
        await closeTrainingAquatic(user.training.id);
      }
      refreshData(filters);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  }

  async function saveTreining(user, isBoot) {
    setLoading(true);
    try {
      if (isBoot) {
        await doneTrainingAquaticBoot(user.training.id);
      } else {
        await doneTrainingAquatic(user.training.id);
      }
      refreshData(filters);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  }

  function setTraining(formUser, trainingId) {
    setLoading(true);
    const obj = {
      trainingId: trainingId,
      load: formUser.getFieldValue("load"),
      vmp1: formUser.getFieldValue("vmp1"),
      pse: formUser.getFieldValue("pse"),
    };
    saveTrainingAqua(obj)
      .then(() => {
        refreshData(filters);
      })
      .catch((err) => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  const showDrawer = () => setOpen(true);
  const closeDrawer = () => setOpen(false);
  const closeDrawerTask = () => {
    setUserTask([]);
    setOpenTask(false);
  };

  const findData = async (filter) => {
    const filledCount = Object.entries(filter).reduce((count, [key, value]) => {
      if (Array.isArray(value)) return count + (value.length > 0 ? 1 : 0);
      if (typeof value === "string")
        return count + (value.trim() !== "" ? 1 : 0);
      if (dayjs.isDayjs(value)) return count + 1;
      if (value !== null && value !== undefined) return count + 1;
      return count;
    }, 0);
    setActiveFilterCount(filledCount);
    setFilters(filter)
    closeDrawer();
    await refreshData(filter);
  };
  return (
    <div className="container-managerial">
      <PageToolbar>
        <Button
          loading={syncLoading}
          style={{
            fontFamily: FONT,
            background: "#09ac9c",
          }}
          type="primary"
          icon={<RotateCw size={18} />}
          onClick={() => {
            updateEvo();
          }}
        >
          Sincronizar EVO
        </Button>
        <Button
          style={{
            fontFamily: FONT,
          }}
          type="primary"
          icon={<Plus size={18} />}
          onClick={updateList}
        >
          Abrir Treino
        </Button>
        <Badge count={activeFilterCount} offset={[-4, 4]}>
          <Button
            style={{
              fontFamily: FONT,
              color: "#000000",
              backgroundColor: "#ffffff",
            }}
            type="primary"
            icon={<Filter size={18} />}
            onClick={showDrawer}
          >
            Filtros
          </Button>
        </Badge>
      </PageToolbar>
      <Row>
        <div style={{ fontFamily: FONT, fontSize: 12, marginBottom: 15 }}>
          Última atualização: {formatTime(lastUpdated)}{" "}
        </div>
      </Row>
      <Spin spinning={loading}>
        {data.length > 0 && (
          <Row gutter={16}>
            <CardTrainings usersTrainings={data} />
          </Row>
        )}
        {dataBoot.length > 0 && (
          <>
            <Divider />
            <Typography.Title
              level={5}
              style={{ margin: 0, textAlign: "center", color: "#979993" }}
            >
              Metódo Atleta
            </Typography.Title>
            <Divider />

            <Row gutter={16}>
              <CardTrainingsBoot usersTrainings={dataBoot} />
            </Row>
          </>
        )}

        {dataBoot.length == 0 && data.length == 0 && (
          <Row gutter={16}>
            <div style={{ textAlign: "center", width: "100%" }}>
              <ListEmptyState subTitle={"A sessão de treino está vazia"} />
            </div>
          </Row>
        )}
      </Spin>
      <DrawerApp
        open={openDetail}
        onClose={onCloseDetail}
        title={userTrainer?.name}
        body={
          <DetailAquatic
            user={userTrainer}
            findSubphaseById={findSubphaseById}
            calcPercent={calcPercent}
            allPhases={phases}
            saveTask={saveTask}
          />
        }
        size={"large"}
        isOnlyView={true}
      />
      <DrawerApp
        open={openChart}
        onClose={onCloseChart}
        title={userTrainer?.name}
        body={
          userTrainer?.isBoot != true ? (
            <ProgressoRadarChart
            phases={phases.filter((f) => f.id == phaseActual?.phase?.id)}
            taskDone={userTrainer?.tasksDone ?? []}
            />
          ) : (
            <FormTrainningBootAqua user={userTrainer} />
          )
        }
        size={"large"}
        isOnlyView={true}
      />
      <DrawerApp
        open={open}
        onClose={closeDrawer}
        title={"Filtros"}
        body={<ManageralAguaFilter findData={findData} />}
        width={drawerWidth(isMobile, 30)}
        isOnlyView={true}
      />
      <DrawerApp
        open={openTask}
        onClose={closeDrawerTask}
        title={"Atividades"}
        body={<Tasks tasks={userTasks} />}
        width={drawerWidth(isMobile, 40)}
        isOnlyView={true}
      />
    </div>
  );
};

export default ManagerialAqua;
